import React, { useState } from "react";
import {
  HeartPulse,
  Stethoscope,
  Settings2,
  Wrench,
  Activity,
  Shield,
  CalendarCheck,
  Plus,
  Home,
} from "lucide-react";
import { useLang } from "@/App";

const ICONS = [Home, HeartPulse, Stethoscope, Settings2, Wrench, Activity, Shield, CalendarCheck];

export default function Services() {
  const { t } = useLang();
  const [openIdx, setOpenIdx] = useState(null);
  return (
    <section id="servicios" className="py-20 md:py-28 bg-slate-50" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-widest text-sky-700">
            {t.services.kicker}
          </p>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold tracking-tight text-blue-950 leading-[1.1]">
            {t.services.title}
          </h2>
          <p className="mt-5 text-lg text-slate-700 leading-relaxed">{t.services.subtitle}</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {t.services.items.map((s, idx) => {
            const Icon = ICONS[idx] || HeartPulse;
            const featured = idx === 0;
            const isOpen = openIdx === idx;
            return (
              <article
                key={idx}
                onClick={() => setOpenIdx(isOpen ? null : idx)}
                className={`group cursor-pointer rounded-2xl p-7 transition-all border ${
                  featured
                    ? "bg-blue-900 text-white border-blue-900 sm:col-span-2 lg:col-span-1 lg:row-span-2"
                    : "bg-white border-slate-200 hover:border-sky-300 hover:shadow-lg"
                }`}
                data-testid={`service-card-${idx}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div
                    className={`grid place-items-center w-14 h-14 rounded-2xl ${
                      featured ? "bg-white/15" : "bg-sky-50 text-sky-700"
                    }`}
                  >
                    <Icon className="w-7 h-7" strokeWidth={2} />
                  </div>
                  <Plus
                    className={`w-5 h-5 transition-transform ${
                      featured ? "text-sky-200" : "text-slate-400"
                    } ${isOpen ? "rotate-45" : "group-hover:rotate-45"}`}
                  />
                </div>
                <h3
                  className={`mt-6 text-xl md:text-2xl font-bold leading-tight ${
                    featured ? "text-white" : "text-slate-900"
                  }`}
                >
                  {s.title}
                </h3>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen
                      ? "max-h-60 opacity-100 mt-3"
                      : "max-h-0 opacity-0 group-hover:max-h-60 group-hover:opacity-100 group-hover:mt-3"
                  }`}
                >
                  <p
                    className={`text-base leading-relaxed ${
                      featured ? "text-sky-50" : "text-slate-600"
                    }`}
                  >
                    {s.desc}
                  </p>
                  {featured && (
                    <a
                      href="#contacto"
                      onClick={(e) => e.stopPropagation()}
                      className="mt-6 inline-flex items-center gap-2 text-sky-200 font-semibold hover:text-white"
                      data-testid="service-featured-cta"
                    >
                      {t.common.bookNow} →
                    </a>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
